import type { ColorScheme } from './colorScheme';

export const palette = [
  {
    main: '#7949cd',
    light: '#f2edfa',
  },
  {
    main: '#dd4848',
    light: '#fceded',
  },
  {
    main: '#7daf13',
    light: '#f2f7e7',
  },
  {
    main: '#15b5e8',
    light: '#e8f8fd',
  },
  {
    main: '#f58316',
    light: '#fef3e8',
  },
  {
    main: '#4e43ce',
    light: '#edecfa',
  },
  {
    main: '#15b1a8',
    light: '#e8f7f6',
  },
  {
    main: '#29ae5e',
    light: '#eaf7ef',
  },
  {
    main: '#e2be00',
    light: '#fcf9e6',
  },
  {
    main: '#e93f79',
    light: '#fdecf2',
  },
];

/** Same hues as `palette`, with slate-tinted fills for dark surfaces. */
const darkPalette = [
  { main: '#B794F6', light: '#3B2A5C' },
  { main: '#FC8181', light: '#5C2A2A' },
  { main: '#C6F06A', light: '#3A4A1C' },
  { main: '#67E8F9', light: '#1A4450' },
  { main: '#FBD38D', light: '#5C3D1A' },
  { main: '#A3BFFA', light: '#2A2A5C' },
  { main: '#5EEAD4', light: '#1A4A45' },
  { main: '#68D391', light: '#1A4A32' },
  { main: '#F6E05E', light: '#4A4418' },
  { main: '#F687B3', light: '#5C2A40' },
];

export function getAvatarPalette(colorScheme: ColorScheme = 'light') {
  return colorScheme === 'dark' ? darkPalette : palette;
}

export const getRandomColor = (colorScheme: ColorScheme = 'light') => {
  const colors = getAvatarPalette(colorScheme);
  return colors[Math.floor(Math.random() * colors.length)];
};

export const getColorForKey = (
  key: string,
  colorScheme: ColorScheme = 'light',
) => {
  const colors = getAvatarPalette(colorScheme);
  if (!key) {
    return colors[0];
  }

  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
};
